import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    addSubscriptionFormAction,
    selectAction,
    userFormAction
} from "../../redux/rootReducer";
import { addSubscriptionSagaAction, getUsersForSubscriptionSagaAction } from "../../redux/sagaActions";
import TextareaAutosize from 'react-textarea-autosize';
import getCost from "../../helpers/getCost";
import CalendarOffline from "../CalendarOffline/CalendarOffline";
import Payment from "../Payment/Payment";
import { ADD_SUBSCRIPTION_FORM_INITIAL, SELECT_INITIAL, USER_FORM_INITIAL } from "../../redux/initialStateConstant";
import Select from "../Select/Select";
import { getPriceForSubscriptionThunk } from "../../redux/thunks/getPriceForSubscription";

const AddSubscriptionForm = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const addSubscriptionForm = useSelector(state => state.addSubscriptionForm);
    const subscription_coaches = useSelector(state => state.subscription_coaches);
    const subscription_types = useSelector(state => state.subscription_types);
    const subscription_durations = useSelector(state => state.subscription_durations);
    const subscription_constraints = useSelector(state => state.subscription_constraints);
    const subscription_workouts_count = useSelector(state => state.subscription_workouts_count);
    const price_for_subscription = useSelector(state => state.price_for_subscription);

    // Таймер для отсрочки запроса посетителей на сервере
    const timer = useRef(0);

    const [calendarType, setCalendarType] = useState(null);
    // Состояние календаря
    const [openCalendar, setOpenCalendar] = useState(false);

    // Выбраная опция из поиска
    const [currentPrice, setCurrentPrice] = useState(null);

    const getUsers = text => {

        if (timer.current) clearTimeout(timer.current);

        if (!text.trim()) {
            dispatch(addSubscriptionFormAction({
                ...addSubscriptionForm,
                user: { id: '', name: '', sum: '', subscriptions: '' },
                users: [],
                userInput: ''
            }));
            return false;
        }

        // Делаем задержку для набора текста
        timer.current = setTimeout(() => {
            dispatch(getUsersForSubscriptionSagaAction({ text, type: 'add' }));
        }, 500);
    };

    useEffect(() => {
        dispatch(getPriceForSubscriptionThunk());
    }, [dispatch]);

    useEffect(() => {
        if (!currentPrice) return;

        // Записываем нужные данные в форму
        const type = subscription_types.find(el => el.id == currentPrice.type);
        const workouts_count = subscription_workouts_count.find(el => el.id == currentPrice.times);
        const duration = subscription_durations.find(el => el.id == currentPrice.duration);
        const coach = subscription_coaches.find(el => el.id == currentPrice.coach);
        const constraint = subscription_constraints.find(el => el.id == currentPrice.time_constraint);

        dispatch(addSubscriptionFormAction({
            ...addSubscriptionForm,
            type,
            workouts_count,
            duration,
            coach,
            constraint,
            payment: [{ index: 1, cost: currentPrice.cost, payment_method: { id: '', name: '' }}],
            discount: { id: '', name: 'Нет скидки', percent: '0' },
            total_sum: currentPrice.cost
        }));
    }, [currentPrice]);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close" onClick={ () => dispatch(addSubscriptionFormAction(ADD_SUBSCRIPTION_FORM_INITIAL)) }/>
                        <div className="form__title">Новый абонемент</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Посетитель (почта или телефон)</div>
                        <div className="dropdown">
                            <input type="text" className="input"
                                   value={
                                       addSubscriptionForm.user?.name ||
                                       addSubscriptionForm.userInput || ''
                                   }
                                   onInput={ event => {
                                       dispatch(addSubscriptionFormAction({
                                           ...addSubscriptionForm,
                                           userInput: event.target.value,
                                           user: { id: '', name: '', sum: '', subscriptions: '' },
                                       }));
                                       // Получение с сервера списка всех пользователей, с совпадением по email или телефону
                                       getUsers(event.target.value);
                                   } }
                            />
                            <div className={ `dropdown__items ${ addSubscriptionForm.userInput ? 'dropdown__items--open' : false }` }>
                                {
                                    addSubscriptionForm.users?.length
                                        ? addSubscriptionForm.users.map(elem => {
                                            return (
                                                <div className="dropdown__item" key={ elem.id }
                                                    onClick={ () => {
                                                        dispatch(addSubscriptionFormAction({
                                                            ...addSubscriptionForm,
                                                            user: elem,
                                                            userInput: ''
                                                        }));
                                                    } }
                                                >{ `${ elem.name } ${ elem.phone }` }</div>
                                            );
                                        })
                                        : <div className="dropdown__item"
                                            onClick={ () => {
                                                // Переходим на страницу с посетителями
                                                history.push('/fitness/users');
                                                // Закрываем форму добавления абонемента
                                                dispatch(addSubscriptionFormAction({
                                                    ...addSubscriptionForm,
                                                    open: false
                                                }));
                                                // Открываем форму добавления посетителя
                                                dispatch(userFormAction({
                                                    ...USER_FORM_INITIAL,
                                                    open: true,
                                                    title: 'Новый посетитель'
                                                }));
                                            } }
                                        >{ `Добавить посетителя` }</div>
                                }
                            </div>
                        </div>
                        {
                            addSubscriptionForm.user.sum !== '' && addSubscriptionForm.user.subscriptions !== '' &&
                            <div className="user__statistic" style={{ marginLeft: 14, marginTop: 3 }}>{ `Сумма: ${
                                addSubscriptionForm?.user?.sum || 0
                            }, Абон: ${
                                addSubscriptionForm?.user?.subscriptions || 0
                            }, Деп: ${ addSubscriptionForm.user?.deposits || 0 }` }</div>
                        }
                    </div>
                    {
                        price_for_subscription.length > 0 &&
                        <div className="form__field">
                            <div className="input__caption">Поиск абонемента</div>
                            <Select
                                current={ currentPrice?.name }
                                type={ 'price_for_subscription' }
                                options={ price_for_subscription }
                                handler={ elem => {
                                    setCurrentPrice(elem);
                                    dispatch(selectAction(SELECT_INITIAL));
                                } }
                                smart={ true }
                            />
                        </div>
                    }

                    <div className="form__field">
                        <div className="input__caption">Дата добавления абонемента и платежа</div>
                        <div className="input input--relative" onClick={ event => {
                            event.preventDefault();
                            event.stopPropagation();
                            setOpenCalendar('addition_date');
                        } }>
                            {
                                addSubscriptionForm.addition_date
                                    ?
                                    new Date(addSubscriptionForm.addition_date).toLocaleDateString('ru-Ru')
                                    :   ''
                            }
                        </div>
                        <CalendarOffline
                            handler={ date => {
                                dispatch(addSubscriptionFormAction({
                                    ...addSubscriptionForm,
                                    addition_date: date
                                }));

                                setOpenCalendar(null);
                            } }
                            open={ openCalendar === 'addition_date' }
                            close={ () => setOpenCalendar(null) }
                        />
                    </div>

                    {
                        subscription_workouts_count.length
                            ?
                            <div className="form__field">
                                <div className="input__caption input__caption--required">Количество посещений</div>
                                <Select
                                    current={ addSubscriptionForm?.workouts_count?.name }
                                    type={ 'workouts_count' }
                                    options={ subscription_workouts_count }
                                    handler={ elem => {
                                        // Сбрасываем текущий элемент прайса
                                        setCurrentPrice(null);

                                        dispatch(addSubscriptionFormAction({
                                            ...addSubscriptionForm,
                                            workouts_count: elem
                                        }));
                                        dispatch(selectAction(SELECT_INITIAL));
                                        getCost({
                                            dispatch,
                                            type: addSubscriptionForm.type.id,
                                            times: elem.id,
                                            duration: addSubscriptionForm.duration.id,
                                            coach: addSubscriptionForm.coach.id,
                                            time_constraint: addSubscriptionForm.constraint.id,
                                            request_type: 'add_subscription',
                                            user: addSubscriptionForm?.user?.id
                                        });
                                    } }
                                    smart={ false }
                                />
                            </div>
                            : false
                    }
                    {
                        subscription_durations.length
                        ?
                            <div className={ `form__field ${ addSubscriptionForm.activation_date && addSubscriptionForm.expire_date ? 'form__field--disable' : '' }` }>
                                <div className="input__caption input__caption--required">Срок действия</div>
                                <Select
                                    current={ addSubscriptionForm?.duration?.name }
                                    type={ 'duration' }
                                    options={ subscription_durations }
                                    handler={ elem => {
                                        // Сбрасываем текущий элемент прайса
                                        setCurrentPrice(null);

                                        dispatch(addSubscriptionFormAction({
                                            ...addSubscriptionForm,
                                            duration: elem
                                        }));
                                        dispatch(selectAction(SELECT_INITIAL));
                                        getCost({
                                            dispatch,
                                            type: addSubscriptionForm.type.id,
                                            times: addSubscriptionForm.workouts_count.id,
                                            duration: elem.id,
                                            coach: addSubscriptionForm.coach.id,
                                            time_constraint: addSubscriptionForm.constraint.id,
                                            request_type: 'add_subscription',
                                            user: addSubscriptionForm?.user?.id
                                        });
                                    } }
                                    smart={ false }
                                    resetVisible={ addSubscriptionForm.duration.id }
                                    resetHandler={ event => {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        dispatch(addSubscriptionFormAction({
                                            ...addSubscriptionForm,
                                            duration: { id: '', name: '' }
                                        }));
                                    } }
                                />
                            </div>
                        : false
                    }
                    <div className={ `form__field form__field--flex ${ addSubscriptionForm.duration.id ? 'form__field--disable' : '' }` }>
                        <div className="form__inline">
                            <div className="input__caption input__caption--required">Действует с</div>
                            <div className="input input--relative" onClick={ event => {
                                event.preventDefault();
                                event.stopPropagation();

                                // Сбрасываем текущий элемент прайса
                                setCurrentPrice(null);

                                setCalendarType('activation_date');
                                setOpenCalendar('activation_date');
                            } }>
                                {
                                    addSubscriptionForm.activation_date
                                    ?
                                        new Date(addSubscriptionForm.activation_date).toLocaleDateString('ru-Ru')
                                    :   ''
                                }
                                {
                                    addSubscriptionForm.activation_date
                                    ?
                                        <i className={ 'form__clear' } onClick={ event => {
                                            event.preventDefault();
                                            event.stopPropagation();
                                            dispatch(addSubscriptionFormAction({
                                                ...addSubscriptionForm,
                                                activation_date: ''
                                            }));
                                        } } style={{ right: 0 }}/>
                                    :   false

                                }
                            </div>
                        </div>
                        <div className="form__inline">
                            <div className="input__caption input__caption--required">Действует по</div>
                            <div className="input input--relative" onClick={ event => {
                                event.preventDefault();
                                event.stopPropagation();

                                // Сбрасываем текущий элемент прайса
                                setCurrentPrice(null);

                                setCalendarType('expire_date');
                                setOpenCalendar('expire_date');
                            } }>
                                {
                                    addSubscriptionForm.expire_date
                                        ?
                                        new Date(addSubscriptionForm.expire_date).toLocaleDateString('ru-Ru')
                                        :   ''
                                }
                                {
                                    addSubscriptionForm.expire_date
                                        ?
                                        <i className={ 'form__clear' } onClick={ event => {
                                            event.preventDefault();
                                            event.stopPropagation();
                                            dispatch(addSubscriptionFormAction({
                                                ...addSubscriptionForm,
                                                expire_date: ''
                                            }));
                                        } } style={{ right: 0 }}/>
                                        :   false

                                }
                            </div>
                        </div>
                        <CalendarOffline
                            handler={ date => {

                                if (calendarType === 'activation_date') {
                                    dispatch(addSubscriptionFormAction({
                                        ...addSubscriptionForm,
                                        activation_date: date
                                    }))
                                }
                                else if (calendarType === 'expire_date') {
                                    dispatch(addSubscriptionFormAction({
                                        ...addSubscriptionForm,
                                        expire_date: date
                                    }))
                                }
                                setOpenCalendar(null);
                                setCalendarType(null);
                            } }
                            open={ openCalendar === 'activation_date' || openCalendar === 'expire_date' }
                            close={ () => setOpenCalendar(null) }
                        />
                    </div>
                    {
                        subscription_types.length
                        ?
                            <div className="form__field">
                                <div className="input__caption input__caption--required">Тип абонемента</div>
                                <Select
                                    current={ addSubscriptionForm?.type?.name }
                                    type={ 'types' }
                                    options={ subscription_types.filter(el => el.hide_subscription !== '1') }
                                    handler={ elem => {
                                        // Сбрасываем текущий элемент прайса
                                        setCurrentPrice(null);

                                        dispatch(addSubscriptionFormAction({
                                            ...addSubscriptionForm,
                                            type: elem
                                        }));
                                        dispatch(selectAction(SELECT_INITIAL));
                                        getCost({
                                            dispatch,
                                            type: elem.id,
                                            times: addSubscriptionForm.workouts_count.id,
                                            duration: addSubscriptionForm.duration.id,
                                            coach: addSubscriptionForm.coach.id,
                                            time_constraint: addSubscriptionForm.constraint.id,
                                            request_type: 'add_subscription',
                                            user: addSubscriptionForm?.user?.id
                                        });
                                    } }
                                    smart={ true }
                                />
                            </div>
                        : false
                    }
                    {
                        subscription_coaches.length > 1
                            ?
                            <div className="form__field">
                                <div className="input__caption">Тренер</div>
                                <Select
                                    current={ addSubscriptionForm?.coach?.name }
                                    type={ 'coaches' }
                                    options={ subscription_coaches }
                                    handler={ elem => {
                                        // Сбрасываем текущий элемент прайса
                                        setCurrentPrice(null);

                                        dispatch(addSubscriptionFormAction({
                                            ...addSubscriptionForm,
                                            coach: elem
                                        }));
                                        dispatch(selectAction(SELECT_INITIAL));
                                        getCost({
                                            dispatch,
                                            type: addSubscriptionForm.type.id,
                                            times: addSubscriptionForm.workouts_count.id,
                                            duration: addSubscriptionForm.duration.id,
                                            coach: elem.id,
                                            time_constraint: addSubscriptionForm.constraint.id,
                                            request_type: 'add_subscription',
                                            user: addSubscriptionForm?.user?.id
                                        });
                                    } }
                                    smart={ true }
                                />
                            </div>
                            : false
                    }
                    {
                        subscription_constraints.length > 1
                            ?
                            <div className="form__field">
                                <div className="input__caption">Ограничения</div>
                                <Select
                                    current={ addSubscriptionForm?.constraint?.name }
                                    type={ 'constraints' }
                                    options={ subscription_constraints }
                                    handler={ elem => {
                                        // Сбрасываем текущий элемент прайса
                                        setCurrentPrice(null);

                                        dispatch(addSubscriptionFormAction({
                                            ...addSubscriptionForm,
                                            constraint: elem
                                        }));
                                        dispatch(selectAction(SELECT_INITIAL));
                                        getCost({
                                            dispatch,
                                            type: addSubscriptionForm.type.id,
                                            times: addSubscriptionForm.workouts_count.id,
                                            duration: addSubscriptionForm.duration.id,
                                            coach: addSubscriptionForm.coach.id,
                                            time_constraint: elem.id,
                                            request_type: 'add_subscription',
                                            user: addSubscriptionForm?.user?.id
                                        });
                                    } }
                                    smart={ false }
                                />
                            </div>
                            : false
                    }
                    <div className="form__field">
                        <div className="input__caption">Примечание</div>
                        <TextareaAutosize
                            className="input input--textarea"
                            value={ addSubscriptionForm.note }
                            onInput={ event => dispatch(addSubscriptionFormAction({
                                ...addSubscriptionForm,
                                note: event.target.value
                            })) }
                        />
                    </div>
                    <Payment
                        payment={ addSubscriptionForm.payment }
                        totalSum={ addSubscriptionForm.total_sum }
                        discountValue={ addSubscriptionForm.discount }
                        handler={ ({ payment, discount, total_sum }) => {
                            dispatch(addSubscriptionFormAction({
                                ...addSubscriptionForm,
                                payment,
                                discount,
                                total_sum
                            }));
                        } }
                    />
                    <div className={ `form__field ${ addSubscriptionForm.activation_date && addSubscriptionForm.expire_date ? 'form__field--disable' : '' }` }>
                        <div className="checkbox__wrapper" onClick={ () => {
                            dispatch(addSubscriptionFormAction({
                                ...addSubscriptionForm,
                                activation: !addSubscriptionForm.activation
                            }));
                        } }>
                            <div className={ `checkbox ${ addSubscriptionForm.activation ? 'checkbox--active' : '' }` }/>
                            <div className="checkbox__caption">Активировать</div>
                        </div>
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                let formattedPayments = [];
                                // Фильтруем и форматируем платежи
                                addSubscriptionForm.payment.forEach(el => {
                                    if (el.cost) {
                                        formattedPayments.push({ cost: el.cost, payment_method: el.payment_method.id });
                                    }
                                });

                                dispatch(addSubscriptionSagaAction({
                                    user: addSubscriptionForm.user.id,
                                    workouts_count: addSubscriptionForm.workouts_count.id,
                                    coach: addSubscriptionForm.coach.id,
                                    type: addSubscriptionForm.type.id,
                                    duration: addSubscriptionForm.duration.id,
                                    constraint: addSubscriptionForm.constraint.id || '',
                                    note: addSubscriptionForm.note,
                                    activation: addSubscriptionForm.activation ? 1 : 0,
                                    activation_date: addSubscriptionForm.activation_date,
                                    expire_date: addSubscriptionForm.expire_date,
                                    payment: JSON.stringify(formattedPayments),
                                    discount: addSubscriptionForm.discount.id,
                                    addition_date: addSubscriptionForm.addition_date
                                }));
                            } }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddSubscriptionForm;